import React from 'react';
import { LangSelectProfile } from 'config';
import { language } from 'static/icons/resizable';
import {
  CustomizedLanguageSelector,
  CustomDropdownIndicator,
  Icon,
  CustomOption,
  CustomControl,
} from 'view/atoms';
import { languageStyleCustom } from './LanguageSelector.styles';

const dropDown = CustomDropdownIndicator(
  <Icon src={language} alt='location' />,
  false,
);

const option = CustomOption('shortLabel');

const control = CustomControl();

export const HeaderLanguageSelector = () => {
  return (
    <CustomizedLanguageSelector
      customDropDownIndicator={dropDown}
      customOption={option}
      labelSelector={(opt) => (opt as LangSelectProfile).shortLabel}
      customStyle={languageStyleCustom}
      customControl={control}
      blockWidth='92px'
    />
  );
};
